import {StyleSheet} from 'react-native';

import {cloudLightest, white} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  base: {
    height: '100%',
    backgroundColor: white,
  },
  base2: {
    flex: 1,
    backgroundColor: white,
  },
  content: {
    flex: 1,
    backgroundColor: cloudLightest,
  },
  sections: {
    paddingBottom: 60,
  },
});
